module.exports = __webpack_public_path__ + "img/tongguo.e934fee9.svg";